import { getFingerPrint } from './finger';
import LayerListener from './listener';
import { handleSessionId } from './sessionId';
import { initCommonParamStorage } from './commonParam';
import { UPLOAD_TYPE } from './define';

const webstorev35Listener = new LayerListener(
  'webstorev35DataLayer',
  UPLOAD_TYPE.webstorev35
);

const webstorev3Listener = new LayerListener(
  'webstorev3DataLayer',
  UPLOAD_TYPE.webstorev3
);

const webstorev2Listener = new LayerListener(
  'webstorev2DataLayer',
  UPLOAD_TYPE.webstorev2
);

const webstorev1Listener = new LayerListener(
  'webstorev1DataLayer',
  UPLOAD_TYPE.webstorev1
);

const creditPayListener = new LayerListener(
  'creditPayDataLayer',
  UPLOAD_TYPE.creditpay
);

const officialPassportDataLayer = new LayerListener(
  'officialPassportDataLayer',
  UPLOAD_TYPE.officialPassport
);

const passportDataLayer = new LayerListener(
  'passportDataLayer',
  UPLOAD_TYPE.passport
);

const csorderDataLayer = new LayerListener(
  'csorderDataLayer',
  UPLOAD_TYPE.csorder
);

const dmaListener = new LayerListener('dmaDataLayer', UPLOAD_TYPE.dma);
const sdkstoreDataLayer = new LayerListener(
  'sdkstoreDataLayer',
  UPLOAD_TYPE.sdkstore
);

const webstorev0Listener = new LayerListener(
  'webstorev0DataLayer',
  UPLOAD_TYPE.webstorev0
);

const initCommonParams = () => {
  getFingerPrint();

  try {
    initCommonParamStorage();
  } catch (e) {
    console.log(e);
  }
};

export const initBiPoint = ({
  dataLayerName,
  needInitCommonParams = true,
  sendSessionEnd = false
}) => {
  needInitCommonParams && initCommonParams();
  handleSessionId({ dataLayerName, sendSessionEnd });
};
